import { Navigate } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import SettingsInventoryTab from './settings/SettingsInventoryTab';
import SettingsPurchaseTab from './settings/SettingsPurchaseTab';
import SettingsApprovalTab from './settings/SettingsApprovalTab';
import SettingsGeneralTab from './settings/SettingsGeneralTab';
import {
  Package,
  ShoppingCart,
  CheckCircle,
  Settings,
} from 'lucide-react';

export default function SettingsPage() {
  return (
    <div className="space-y-6">
      {/* Page header */}
      <div>
        <h1 className="text-3xl font-heading font-bold text-text-primary">
          Settings
        </h1>
        <p className="text-text-secondary mt-1">
          Configure application settings and preferences
        </p>
      </div>

      {/* Settings Tabs */}
      <Tabs defaultValue="inventory" className="space-y-6">
        <TabsList className="grid w-full grid-cols-4 lg:w-auto lg:inline-flex">
          <TabsTrigger value="inventory" className="gap-2">
            <Package className="h-4 w-4" />
            <span className="hidden sm:inline">Inventory</span>
          </TabsTrigger>
          <TabsTrigger value="purchase" className="gap-2">
            <ShoppingCart className="h-4 w-4" />
            <span className="hidden sm:inline">Purchase</span>
          </TabsTrigger>
          <TabsTrigger value="approvals" className="gap-2">
            <CheckCircle className="h-4 w-4" />
            <span className="hidden sm:inline">Approvals</span>
          </TabsTrigger>
          <TabsTrigger value="general" className="gap-2">
            <Settings className="h-4 w-4" />
            <span className="hidden sm:inline">General</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="inventory">
          <SettingsInventoryTab />
        </TabsContent>

        <TabsContent value="purchase">
          <SettingsPurchaseTab />
        </TabsContent>

        <TabsContent value="approvals">
          <SettingsApprovalTab />
        </TabsContent>

        <TabsContent value="general">
          <SettingsGeneralTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
